import { modalRenderer } from '~/modal/modalRendererRegistry';
import { AfterMigrationMapPrepareModal } from './afterMigrationMapPrepareModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    AfterMigrationMapPrepare: undefined;
  }
}
modalRenderer.register('AfterMigrationMapPrepare', AfterMigrationMapPrepareModal);
